import { useEffect, useRef, useState } from "react";
import Input from "@Components/Input";
import styles from "../../PartnerLeadFormModal.module.scss";
import DropdownIcon from "@Icons/DropdownIcon";
import useClickOutside from "hooks/useOutsideClick";
// import { shallowEqual, useSelector } from "react-redux";
// import { AppState } from "@Store/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import { INTAKE_OPTIONS_MAP } from "@Components/LeadFormV2/constants";
import wrapperHOC from "@Utils/wrapperHOC";

const IntakeDropdown = ({ error, setErrors, selectedIntake, setSelectedIntake }: any) => {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const ref = useRef(null);

  // const { intake } = useSelector(
  //   ({ leadFormModal }: AppState) => ({
  //     intake: leadFormModal.intake,
  //   }),
  //   shallowEqual,
  // );

  const handleSelectIntake = (intakeOption: any) => {
    setSelectedIntake(intakeOption);
    setErrors((errors: any) => ({ ...errors, intake: "" }));
    setShowOptions(false);
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Tab") {
      setShowOptions(false);
    }
  };

  useClickOutside(ref, () => setShowOptions(false));

  useEffect(() => {
    if (selectedIntake && !selectedIntake?.label) {
      setSelectedIntake(INTAKE_OPTIONS_MAP.find((intake) => intake.value === selectedIntake));
    }
  }, [selectedIntake]);

  return (
    <div className={styles.universityDropdownContainer} ref={ref}>
      <Input
        type="dropdown"
        label="Intake"
        placeholder="Select Intake"
        value={selectedIntake ? selectedIntake?.label : ""}
        onFocus={() => setShowOptions(true)}
        onKeyDown={(e: any) => handleKeyDown(e)}
        handleClear={() => {
          setSelectedIntake({ label: "", value: "" });
          setShowOptions(false);
        }}
        clearable
        rightIconClassName={error ? styles.rightIconWithError : ""}
        rightIcon={!selectedIntake?.label && <DropdownIcon size={15} />}
        showErrorMessage={Boolean(error)}
        error={error}
        required
      />
      {showOptions && (
        <div
          className={formatClassNames(
            styles.universityDropdownOptContainer,
            styles.intakeDropdownContainer,
          )}
        >
          {INTAKE_OPTIONS_MAP.map((option: any) => (
            <div
              key={option.value}
              className={formatClassNames(
                styles.option,
                option.value === selectedIntake?.value ? styles.selected : "",
              )}
              onClick={() => handleSelectIntake(option)}
              role="button" // Add role="button" to make it accessible
              tabIndex={0} // Add tabIndex to make it focusable
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleSelectIntake(option);
                }
              }}
            >
              <div>{option.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default wrapperHOC(IntakeDropdown, {
  componentName: "IntakeDropdown-Dropdown-PartnerLeadFormModal-Global",
  showForChina: true,
});
